import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogContent, IconButton } from '@mui/material'
import SumsubWebSdk from '@sumsub/websdk-react'
import { useLocale } from 'ra-core'
import { useDataProvider, useRecordContext, useResourceContext } from 'react-admin'

const SumsubDialog = ({ isOpen, setIsOpen, data }) => {
  const lang = useLocale()
  const dataProvider = useDataProvider()
  const record = useRecordContext()
  const resource = useResourceContext()

  return (
    <Dialog
      open={isOpen}
      onClose={setIsOpen}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: 'transparent',
          backgroundImage: 'none',
          boxShadow: 'none',
          maxWidth: '50vw',
          minWidth: 500,
          width: '50vw',
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={() => setIsOpen(false)}
        sx={() => ({ position: 'absolute', right: 8, top: 8 })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ backgroundColor: 'transparent', marginTop: 4, marginBottom: 0 }}>
        <SumsubWebSdk
          accessToken={data.access_token}
          expirationHandler={async () => {
            data = dataProvider.action(resource, record.id, 'START_USER_KYC')
            return data.access_token
          }}
          config={{ lang }}
          options={{ enableScrollIntoView: true, adaptIframeHeight: true }}
          onError={(err) => {
            Sentry.captureException(err)
          }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default SumsubDialog
